"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _set2 = _interopRequireDefault(require("lodash/set"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _text = require("@mmc/text");
var _configuratorLargeSummary = require("@mmc/configurator-large-summary");
var _commonCta = require("@mmc/common-cta");
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _commonLibs = require("@mmc/common-libs");
var _reactLazyLoadImageComponent = require("react-lazy-load-image-component");
var _clsx = _interopRequireDefault(require("clsx"));
var _disclaimer = _interopRequireDefault(require("./disclaimer/disclaimer"));
var _configurator = _interopRequireDefault(require("../styles/configurator.css"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp,
  appendImageTransforms = dataUtils.appendImageTransforms;
var FUELTYPES = {
  'gasoline': ['Gasolina', 'Bi-Fuel', 'Unleaded'],
  'glp': ['Gasolina/GLP'],
  'hybrid': ['PHEV', 'HEV', 'MHEV Gasolina', 'MHEV', 'Plug-in Híbrido']
};
var getFuelValueByFuelType = function getFuelValueByFuelType(fuelType) {
  var _mappedFuelType;
  var mappedFuelType;
  if (fuelType) {
    Object.values(FUELTYPES).forEach(function (names, index) {
      var itemFound = names.filter(function (item) {
        return item.toLowerCase() === fuelType.toLowerCase();
      });
      if (itemFound && itemFound.length > 0) {
        mappedFuelType = Object.keys(FUELTYPES)[index];
      }
      ;
    });
  }
  return mappedFuelType ? (_mappedFuelType = mappedFuelType) == null ? void 0 : _mappedFuelType.toLowerCase() : fuelType;
};
var SummaryStep = /*#__PURE__*/function (_React$PureComponent) {
  function SummaryStep() {
    return _React$PureComponent.apply(this, arguments) || this;
  }
  (0, _inheritsLoose2["default"])(SummaryStep, _React$PureComponent);
  var _proto = SummaryStep.prototype;
  _proto.handleCtaClick = function handleCtaClick(ctaClicked) {
    var _summary$fuelType;
    var _this$props = this.props,
      market = _this$props.config.market,
      summary = _this$props.data.summary;
    var url = ctaClicked.url;
    var modelName = summary && summary.vehicle && summary.vehicle.name ? summary.vehicle.name : '';
    var fuelType = getFuelValueByFuelType(summary == null || (_summary$fuelType = summary.fuelType) == null ? void 0 : _summary$fuelType.label);
    if ((market.toLowerCase() === 'es' || market.toLowerCase() === 'pt' || market.toLowerCase() === 'fi') && typeof window !== 'undefined' && window.dataLayer) {
      if (url.includes('/prueba') || url.includes('/test-drive') || url.includes('/varaa-koeajo')) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'test_drive_request_click',
          comp_product: {
            position: 'page',
            vehicle_type: 'car',
            brand: 'mitsubishi',
            product_condition: 'new',
            model: modelName ? modelName.toLowerCase() : null,
            version: null,
            fuel_type: fuelType ? fuelType.toLowerCase() : null,
            dealer_name: null
          }
        });
      }
    }
    if (market.toLowerCase() === 'ro' && typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'configurator_end',
        action: ctaClicked.label || null
      });
    }
  };
  _proto.handleExtraCtaClick = function handleExtraCtaClick(ctaClicked) {
    var _this$props2 = this.props,
      market = _this$props2.config.market,
      _this$props2$data = _this$props2.data,
      summary = _this$props2$data.summary,
      vehicleInfo = _this$props2$data.vehicleInfo;
    if (market.toLowerCase() === 'ro' && typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'configurator_end',
        action: ctaClicked.label || null
      });
    }
    var isClickShopURL = ctaClicked.url.includes('clickshop');
    if (market.toLowerCase() === 'ca' && typeof window !== 'undefined' && isClickShopURL && window.dataLayer) {
      var _summary$vehicle, _summary$model, _summary$model2;
      var nameplate = (0, _commonLibs.getNameplateByVehicleName)(summary == null || (_summary$vehicle = summary.vehicle) == null ? void 0 : _summary$vehicle.name);
      var dataCollection = {
        event: 'clickshop_view_vehicle',
        nameplate: nameplate,
        vehicle_year: summary == null || (_summary$model = summary.model) == null ? void 0 : _summary$model.year,
        vehicle_trim: summary == null || (_summary$model2 = summary.model) == null || (_summary$model2 = _summary$model2.name) == null ? void 0 : _summary$model2.toLowerCase()
      };
      dataCollection = (0, _commonLibs.cleanObject)(dataCollection);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(dataCollection);
    }
  };
  _proto.render = function render() {
    var _this = this;
    var _this$props3 = this.props,
      data = _this$props3.data,
      changeStepEvents = _this$props3.changeStepEvents,
      rootUrl = _this$props3.rootUrl,
      direction = _this$props3.direction,
      market = _this$props3.market,
      config = _this$props3.config,
      _this$props3$theme = _this$props3.theme,
      theme = _this$props3$theme === void 0 ? {} : _this$props3$theme,
      addPriceDisclaimer = _this$props3.addPriceDisclaimer,
      priceDisclaimerId = _this$props3.priceDisclaimerId,
      disclaimerData = _this$props3.disclaimerData;
    var changeModel = changeStepEvents.changeModel,
      changeColor = changeStepEvents.changeColor,
      changeFabric = changeStepEvents.changeFabric,
      changePackages = changeStepEvents.changePackages,
      changeAccessories = changeStepEvents.changeAccessories;
    var summary = data.summary,
      offers = data.offers,
      cta = data.cta,
      extraButtonCta = data.extraButtonCta,
      thirdButtonCta = data.thirdButtonCta,
      msrp = data.msrp,
      clickShopEnabled = data.clickShopEnabled,
      calcLabels = data.calcLabels,
      clickShopBridgePageUrl = data.clickShopBridgePageUrl;
    var totalPrice = summary.totalPrice,
      vehicleName = summary.vehicle.name,
      modelName = summary.model.name;
    var backgroundImage = handleNestedProp(data, 'data.backgroundImage.image');
    var hasBackgroundImage = backgroundImage !== ' ' && backgroundImage !== '';
    var backgroundImageWidth = 1600;
    var mainImageWidth = 1200;
    var summaryFinanceData = {
      totalPrice: (0, _get2["default"])(totalPrice, 'value'),
      basePrice: (0, _get2["default"])(totalPrice, 'baseValue'),
      fullVehicleName: vehicleName + " " + modelName,
      labels: _objectSpread(_objectSpread({}, calcLabels), {}, {
        clickShopEnabled: clickShopEnabled,
        suffix: msrp || 'MSRP',
        cta1Label: cta.label,
        cta1Link: cta.url,
        cta1OpenNewTab: cta.openNewTab,
        cta2Label: extraButtonCta.label,
        cta2Link: extraButtonCta.url,
        cta2OpenNewTab: extraButtonCta.openNewTab,
        cta3Label: thirdButtonCta && thirdButtonCta.label,
        cta3Link: thirdButtonCta && thirdButtonCta.url,
        cta3OpenNewTab: thirdButtonCta && thirdButtonCta.openNewTab
      })
    };
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['container-fluid'] + " " + _configurator["default"].summaryHero
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + _configurator["default"].summaryBackground
    }, hasBackgroundImage && /*#__PURE__*/_react["default"].createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
      className: "" + _configurator["default"].summaryBackgroundImage,
      src: appendImageTransforms(backgroundImage, backgroundImageWidth),
      alt: handleNestedProp(data, 'data.backgroundImage.altText')
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.row + " " + _configurator["default"].infoWrapper,
      dir: direction
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-12'] + " " + theme['col-sm-6'] + " " + theme['col-md-7'] + " " + theme['last-sm'] + " " + _configurator["default"].shortImageWrap + " " + (backgroundImage === ' ' || backgroundImage === '' ? _configurator["default"].defaultBg : '')
    }, /*#__PURE__*/_react["default"].createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
      className: _configurator["default"].shortImage,
      src: appendImageTransforms(handleNestedProp(data, 'data.summary.selectedVehicleImage.image'), mainImageWidth),
      alt: handleNestedProp(data, 'data.summary.selectedVehicleImage.altText')
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: _configurator["default"].summaryShort + " " + theme['col-xs-12'] + " " + theme['col-sm-5'] + " " + theme['col-md-3'] + " " + theme['col-sm-offset - 1'] + " " + theme['col-md-offset - 1']
    }, handleNestedProp(data, 'data.headingText.title') !== ' ' && /*#__PURE__*/_react["default"].createElement(_text.Text, {
      tag: "h2",
      text: (handleNestedProp(data, 'data.headingText.title') ? handleNestedProp(data, 'data.headingText.title') : '') + " " + handleNestedProp(data, 'data.summary.vehicle.name'),
      className: theme.headingThree + " " + _configurator["default"].shortHeading,
      disclaimerData: disclaimerData
    }), handleNestedProp(data, 'data.headingText.text') !== ' ' && /*#__PURE__*/_react["default"].createElement(_text.Text, {
      tag: "p",
      text: handleNestedProp(data, 'data.headingText.text'),
      className: theme.bodyCopy + " " + _configurator["default"].shortCopy,
      disclaimerData: disclaimerData
    }), thirdButtonCta && thirdButtonCta.url && /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx["default"])(_configurator["default"].ctaWrapperSummary, _configurator["default"].thirdButtonCta)
    }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      spanClasses: [_configurator["default"].fullWidthCta],
      data: (0, _set2["default"])(thirdButtonCta, 'priority', 'high'),
      theme: theme
    })), extraButtonCta && extraButtonCta.url && /*#__PURE__*/_react["default"].createElement("div", {
      className: _configurator["default"].ctaWrapperSummary
    }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      spanClasses: [_configurator["default"].fullWidthCta],
      data: (0, _set2["default"])(extraButtonCta, 'priority', 'high'),
      theme: theme,
      mouseDownEvent: function mouseDownEvent() {
        return _this.handleExtraCtaClick(extraButtonCta);
      }
    })), cta && cta.url && /*#__PURE__*/_react["default"].createElement("div", {
      className: _configurator["default"].ctaWrapperSummary
    }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      spanClasses: [_configurator["default"].fullWidthCta],
      data: (0, _set2["default"])(cta, 'priority', 'medium'),
      theme: theme,
      mouseDownEvent: function mouseDownEvent() {
        return _this.handleCtaClick(cta);
      }
    }))))), /*#__PURE__*/_react["default"].createElement(_configuratorLargeSummary.ConfiguratorLargeSummary, {
      data: _objectSpread(_objectSpread(_objectSpread({}, summary), offers), {}, {
        summaryFinanceData: summaryFinanceData
      }),
      theme: theme,
      rootUrl: rootUrl,
      changeModel: changeModel,
      changeColor: changeColor,
      changeFabric: changeFabric,
      changePackages: changePackages,
      changeAccessories: changeAccessories,
      direction: direction,
      market: market,
      summary: summary,
      addPriceDisclaimer: addPriceDisclaimer,
      priceDisclaimerId: priceDisclaimerId,
      disclaimerData: disclaimerData
    }), data.disclaimer && market !== 'us' && /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['container-fluid'] + " " + _configurator["default"].summaryDisclaimer,
      dir: direction
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme.row
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-12'] + " " + theme['col-sm-5'] + " " + theme['col-sm-offset - 1']
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: theme.smallType + " " + _configurator["default"].stepDisclaimer
    }, data.disclaimer)))), data.disclaimer && market === 'us' && /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-12'] + " " + theme['col-md-offset-1'] + " " + theme['col-md-10']
    }, /*#__PURE__*/_react["default"].createElement(_disclaimer["default"], {
      theme: theme,
      headline: "Disclaimer",
      content: data.disclaimer
    })));
  };
  return SummaryStep;
}(_react["default"].PureComponent);
var mapStateToProps = function mapStateToProps(state) {
  return {
    config: state.Config
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(SummaryStep);